exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-box-wrapper[data-v-86e5ca72] {\n  position: relative;\n}\n.fake-input-wrapper[data-v-86e5ca72] {\n  position: absolute;\n}\n", ""]);

